import { createReducer } from "@reduxjs/toolkit";
import moment from "moment";
import { postRicercaLotti, setPaginaSelezionataAction, setRicercaDataFine, setRicercaDataInizio, setRicercaNome, setRicercaStatoCampagna } from "./actions";
import { HomeCampagnaReducerType } from "./types";

const initialState: HomeCampagnaReducerType = {
  lottoCaricato: undefined,
  dataInizio: moment().subtract('7', 'days').toDate(),
  dataFine: moment().toDate(),
  pageCampagna: undefined,
  paginaSelezionata: 1,
  formRicerca: {
    nome: '',
    dataInserimentoInizio: moment().subtract('7', 'days').toDate(),
    dataInserimentoFine: moment().toDate(),
    statoCampagna: 0
  },
}

export const homeCampagnaReducer = createReducer(initialState, (builder) => {

  builder
    .addCase(postRicercaLotti.fulfilled, (state, action) => {
      state.pageCampagna = action.payload
    })
    .addCase(setPaginaSelezionataAction, (state, action) => {
      state.paginaSelezionata = action.payload;
    })
    .addCase(setRicercaNome, (state, action) => {
      state.formRicerca.nome = action.payload;
    })
    .addCase(setRicercaDataInizio, (state, action) => {
      state.formRicerca.dataInserimentoInizio = action.payload;
    })
    .addCase(setRicercaDataFine, (state, action) => {
      state.formRicerca.dataInserimentoFine = action.payload;
    })
    .addCase(setRicercaStatoCampagna, (state, action) => {
      state.formRicerca.statoCampagna = action.payload;
    })
});
